import { Button, Form, Input } from 'antd';
import React, { useContext } from 'react'
import { Contact } from '../../Models/Contact';
import { addContact } from '../../Api/Contact';
import { PromiseSesionContext } from '../../Machines/ErrorMachine';

interface Props{
    closeModal?:  () => void
    description?: string
}

const ContactForm = ({closeModal,description}:Props) => {
    const [loading, setLoading] = React.useState<boolean>(false);
        const {error, sendError} = useContext(PromiseSesionContext);
    type FieldType = {
        email: string;
        phone:string;

      };

    const  onFinish = async (values: FieldType) =>{
        try{
            setLoading(true)
            let contact:Contact ={
                email:values.email,
                phone:values.phone,
                description: description || ""
            }

            let response = await addContact(contact)
            
            sendError({type: "ERROR", data:{message:`¡Listo! Su solicitud ha sido enviada con éxito. Lo contactaremos en unos minutos.`, type:"success"}})
            setLoading(false)
            if(closeModal){
                
                closeModal()
            }
        }
        catch(error:any){
            sendError({type: "ERROR", data:{message:"Ha ocurrido un error al enviar la solicitud. Por favor, inténtelo de nuevo.", type:"error"}})
        }

    }
    return (
    <div>
       <Form
        disabled={loading}
        name="basic"
        className='FormLoginComponentForm'
        layout={"vertical"}
        onFinish={onFinish}
        style={{width:"100%"}}
        autoComplete="off">

            <Form.Item<FieldType>
            label={"Correo"}
            
            name="email"
            style={{width:"100%"}}
            rules={[{ required: true, message: "El correo es requerido"  },{ type: 'email', message: 'Por favor, ingresa un correo válido.' }]}>
            <Input style={{width:"100%"}}   />

            </Form.Item>

            <Form.Item<FieldType>
            label={"Número de WSP"}
            name="phone"
            style={{width:"100%"}}
            validateTrigger={['onBlur','onChange' ]} 
            rules={[{ required: true, message: "El número de WSP es requerido" },
                { 
                    pattern: /^04\d{9}$/,
                    message: 'El número debe empezar con 04 y tener 11 dígitos en total.'
                }
            ]}>
            <Input style={{width:"100%"}}  />

            </Form.Item>

        <Button style={{width:"100%"}} loading={loading}  type="primary" htmlType="submit">Enviar</Button>
        </Form>
    </div>
  )
}

export default ContactForm